var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('datatable-bulks',{attrs:{"ref-table":_vm.refTable}}),_vm._v(" "),_c('datatable-exports',{attrs:{"ref-table":_vm.refTable}}),_vm._v(" "),_c('datatable-filters',{attrs:{"ref-table":_vm.refTable,"ref-map":_vm.refMap}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }